<template>
  <base-section id="404">
    <base-heading title="404" />

    <base-subheading
      class="primary--text"
      title="Attans!"
    />

    <base-subheading
      space="8"
      title="Det verkar som att sidan inte finns"
    />

    <div class="text-center">
      <base-btn :to="{ name: 'Aktuellt' }">
        Ta mig härifrån!
      </base-btn>
    </div>
  </base-section>
</template>

<script>
  export default {
    name: 'FourOhFour',

    provide: {
      heading: { align: 'center' },
    },
  }
</script>
